import { AES, enc } from 'crypto-js'
import { ObjectGeneric } from '../types/generals'

export enum LocaleNameType {
  SETTING = 'setting',
  STATE = 'state',
  QUESTIONNAIRE = "QUESTIONNAIRE"
}

const key = process.env.REACT_APP_ENCRYPT_KEY ?? ''

const decrypt = (text: string) => {
  return AES.decrypt(text, key).toString(enc.Utf8)
}
const encrypt = (text: string) => {
  return AES.encrypt(text, key).toString()
}

export const getLocalStorage = <T,>(name: LocaleNameType = LocaleNameType.STATE) => {
  const value = localStorage.getItem(name)
  try {
    if (value) {
      return JSON.parse(decrypt(value)) as T
    } else {
      return {} as T
    }
  } catch (e) {
    return {} as T
  }
}

export const setLocalStorage = ({
  body,
  name,
}: {
  name: LocaleNameType
  body: ObjectGeneric
}) => {
  const encryptedValue = encrypt(JSON.stringify(body))
  localStorage.setItem(name, encryptedValue)
}

export { decrypt, encrypt }